import { render, staticRenderFns } from "./ComplaintsPage.vue?vue&type=template&id=7fc30f46&scoped=true"
import script from "./ComplaintsPage.vue?vue&type=script&lang=ts"
export * from "./ComplaintsPage.vue?vue&type=script&lang=ts"
import style0 from "./ComplaintsPage.vue?vue&type=style&index=0&id=7fc30f46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc30f46",
  null
  
)

export default component.exports